import styled, { css } from "styled-components/macro";
import {
  colorGrey,
  colorWhite,
  colorYellow,
  buttonShadow,
} from "../../../utils/css/colors";
import { mobile } from "../../../utils/css/media";
import { body16 } from "../../../utils/css/typography";
import { footerHeight } from "../../../utils/css/sizes";
import { isIOS } from "react-device-detect";

export const FooterContainer = styled.div<{
  lng: string;
  isIOSModalOpen: boolean;
}>`
  position: static;
  bottom: 0;
  width: 100%;
  height: ${footerHeight}px;
  padding: 15px 97px 15px 40px;
  background-color: ${colorGrey};
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  direction: ${({ lng }) => (lng === "he" ? "ltr" : "rtl")};

  ${mobile(css<{ isIOSModalOpen: boolean }>`
    height: fit-content;
    flex-direction: column-reverse;
    align-items: center;
    padding: 15px 15px;
    position: ${({ isIOSModalOpen }) =>
      isIOSModalOpen && isIOS ? "fixed" : "static"};
    bottom: 0;
    left: 0;
    right: 0;
  `)}
`;

export const DivFlexReverse = styled.div`
  display: flex;
  flex-direction: row-reverse;

  ${mobile(css`
	width:100%
		flex-direction: column;
	`)}
`;

export const IconContainer = styled.div`
  display: flex;
  margin: -3px 0;

  ${mobile(css`
    justify-content: center;
    width: 100%;
  `)}
`;

export const LinkColor = styled.a<{
  isBorder?: string;
  align?: string;
  disableAfter?: boolean;
}>`
  color: ${colorWhite};
  margin-inline-start: 10px;
  white-space: nowrap;
  cursor: pointer;

  &::after {
    content: ${({ disableAfter }) => (disableAfter ? "none" : "''")};
    border-inline-end: ${({ isBorder, align }) =>
      isBorder === "true" && align === "right" ? "1px solid white" : "unset"};
    border-inline-start: ${({ isBorder, align }) =>
      isBorder === "true" && align === "left" ? "1px solid white" : "unset"};
    margin-inline-end: 11px;
    margin-inline-start: ${({ isBorder, align }) =>
      isBorder === "true" && align === "left" ? "11px" : "unset"};
  }

  ${mobile(css`
    margin: 11px 0 0 0;
    &::after {
      content: "";
      border-right: unset;
      margin-inline-end: 0;
    }
  `)}
`;

export const FooterLink = styled.div<{
  isBorder?: string;
  align?: string;
  disableAfter?: boolean;
}>`
  color: ${colorWhite};
  margin-inline-end: 10px;
  white-space: nowrap;
  display: inline;
  cursor: pointer;
  font-size: 18px;
  margin-inline-start: 10px;

  &::after {
    content: ${({ disableAfter }) => (disableAfter ? "none" : "''")};
    border-inline-end: ${({ isBorder, align }) =>
      isBorder === "true" && align === "right" ? "1px solid white" : "unset"};
    border-inline-start: ${({ isBorder, align }) =>
      isBorder === "true" && align === "left" ? "1px solid white" : "unset"};
    margin-inline-end: 11px;
    margin-inline-start: ${({ isBorder, align }) =>
      isBorder === "true" && align === "left" ? "11px" : "unset"};
  }

  ${mobile(css`
    margin: 11px 0 0 0;
    &::after {
      content: "";
      border-right: unset;
      margin-inline-end: 0;
    }
  `)}
`;

// @ts-ignore
export const LinkBold = styled(LinkColor)`
  font-weight: bold;
  color: ${colorYellow};
  font-size: ${body16};
`;

export const InlineDiv = styled.div`
  display: inline;

  ${mobile(css`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-end;
  `)}
`;

// @ts-ignore
export const InlineDivFlexStart = styled(InlineDiv)`
  ${mobile(css`
    align-items: flex-start;
  `)}
`;

export const LinksContainer = styled.div`
  color: #ffff;
  padding: 7px 0;
  margin-inline-start: 25px;

  ${mobile(css`
    order: 1;
    margin-inline-start: 0;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  `)}
`;

export const IconImg = styled.img`
  margin: 0 7px;
  width: 35px;
  cursor: pointer;

  ${mobile(css`
    margin: 0 13px;
  `)}
`;

export const IconImgFaceBookGroup = styled(IconImg)`
  width: 38px;
`;

export const IconImgInstagram = styled(IconImg)`
  width: 36px;
`;

export const MoveoLogoContainer = styled.div<{ lng: string }>`
  color: ${colorWhite};
  display: flex;
  align-items: center;
  height: 40px;
  flex-direction: ${({ lng }) => (lng === "he" ? "" : "row-reverse")};

  ${mobile(css`
    order: -1;
    align-items: unset;
    margin-top: 26px;
    flex-direction: column;
    height: 270px;
  `)}
`;

export const FooterSupportedText = styled.div`
  opacity: 0.3;
  margin-left: 25px;
  font-size: 12px;
  ${mobile(css`
  margin-left: 0;
  `)}
`;

export const MoveoLogoImg = styled.img<{ lng: string }>`
  display: flex;
  margin-inline-: 15px;
  margin-inline-end: ${({ lng }) => (lng === "he" ? "" : "5px")};
  align-self: end;
  height: 16px;

  ${mobile(css`
    height: 22px;
    width: 100%;
    margin-inline-start: 0;
  `)}
`;

export const VeidatHatviotLogoImg = styled.img<{ lng: string }>`
  display: flex;
  margin-inline-start: 15px;
  margin-inline-end: ${({ lng }) => (lng === "he" ? "" : "5px")};
  align-self: end;
  height: 50px;
  background: #ffffff30;
  padding: 4px;
  border-radius: 6px;

  ${mobile(css`
    height: 57px;
    margin: 0 auto;
    margin-top: 10px;
  `)}
`;

export const ExitModalDiv = styled.div`
  position: fixed;
  top: calc(17% - 120px);
  left: calc(39% - 120px);
  width: 33px;
  height: 31px;
  background-color: ${colorWhite};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${buttonShadow};
  cursor: pointer;

  ${mobile(css`
    top: 24px;
    left: 9px;
    display: none;
  `)};
`;
